@if (formField()().touched() && formField()().invalid()) {
    <ng-container>{{errors()}}</ng-container>
}